module.exports = __webpack_public_path__ + "img/head.1c931282.png";